<div class="course-player-container">
  <div class="course-header">
    <div class="breadcrumb">
      <a href="/dashboard/academy">Academy</a> / <span>{{course.title}}</span>
    </div>
    
    <div class="course-title-section">
      <h1>{{course.title}}</h1>
      <div class="course-categories">
        <span *ngFor="let category of course.categories" class="course-category">{{category}}</span>
      </div>
    </div>
  </div>
  
  <div class="course-content">
    <div class="video-container">
      <iframe 
        *ngIf="videoUrl" 
        [src]="videoUrl" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
      
      <div class="video-controls">
        <div class="lesson-navigation">
          <button class="nav-button" [disabled]="isFirstLesson()" (click)="previousLesson()">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 3l-4 5 4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Anterior
          </button>
          
          <button class="playlist-button" (click)="toggleLessonList()">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 4h12M2 8h12M2 12h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Lecciones
          </button>
          
          <button class="nav-button" [disabled]="isLastLesson()" (click)="nextLesson()">
            Siguiente
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 3l4 5-4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        
        <div class="lesson-actions">
          <button class="action-button" (click)="markLessonCompleted(currentLesson)">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 8l3 3 7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Marcar como completado
          </button>
          
          <button class="action-button">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 9v3a1 1 0 001 1h6a1 1 0 001-1V9M8 10V3m0 0L6 5m2-2l2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Compartir
          </button>
        </div>
      </div>
    </div>
    
    <div class="lesson-details" [class.show-lessons]="showLessonList">
      <div class="lesson-list-header">
        <h2>Contenido del Curso</h2>
        <div class="progress-indicator">
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="calculateProgress()"></div>
          </div>
          <span>{{calculateProgress()}}% Completado</span>
        </div>
        <button class="close-button" (click)="toggleLessonList()">×</button>
      </div>
      
      <div class="lesson-list">
        <div *ngFor="let lesson of course.lessons" 
             class="lesson-item" 
             [class.active]="lesson.id === currentLesson"
             [class.completed]="lesson.completed"
             (click)="loadLesson(lesson.id)">
          <div class="lesson-item-content">
            <div class="lesson-status">
              <svg *ngIf="lesson.completed" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7" fill="currentColor"/>
                <path d="M5 8l2 2 4-4" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <div *ngIf="!lesson.completed" class="status-circle"></div>
            </div>
            
            <div class="lesson-info">
              <h3>{{lesson.title}}</h3>
              <p>{{lesson.description}}</p>
              <span class="lesson-duration">
                <svg width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" fill="none"/>
                  <path d="M8 5v3l2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                {{lesson.duration}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="course-description">
    <div class="course-info">
      <h2>Sobre este curso</h2>
      <p>{{course.description}}</p>
      
      <div class="instructor-section">
        <div class="instructor-avatar">
          <img [src]="course.instructorAvatar" alt="Instructor">
        </div>
        <div class="instructor-info">
          <h3>{{course.instructor}}</h3>
          <p>{{course.instructorTitle}}</p>
        </div>
      </div>
      
      <div class="course-stats">
        <div class="stat-item">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M8 5v3l2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <span>{{course.duration}}</span>
        </div>
        
        <div class="stat-item">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1l2 4 4 1-3 3 1 4-4-2-4 2 1-4-3-3 4-1z" fill="none" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          <span>{{course.rating}} ({{course.ratingCount}} reseñas)</span>
        </div>
        
        <div class="stat-item">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 3h12v10H2z" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M2 6h12M6 3v10" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          <span>{{course.lessonsCount}} lecciones</span>
        </div>
      </div>
    </div>
  </div>
  
  <div class="related-courses">
    <h2>Cursos relacionados</h2>
    
    <div class="courses-grid">
      <div *ngFor="let course of relatedCourses" class="course-card">
        <div class="course-image">
          <img [src]="course.image" alt="Course thumbnail">
        </div>
        <div class="course-info">
          <h3>{{course.title}}</h3>
          <p class="instructor">{{course.instructor}}</p>
          <div class="price-section">
            <span *ngIf="!course.isFree" class="price">S/.{{course.price}}</span>
            <span *ngIf="course.isFree" class="free-label">Gratis</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 